import { publicIdSchema } from "@rosc/contracts";

function obsoleteKeys(account: string, prefix: string): string[] {
  const separator = account.lastIndexOf(":");
  if (!publicIdSchema.safeParse(account.slice(separator + 1)).success)
    return [];
  const uid = account.slice(0, separator);
  return Object.keys(sessionStorage).filter((key) => {
    if (!key.startsWith(prefix)) return false;
    try {
      const oldAccount = decodeURIComponent(
        key.slice(prefix.length).split(":")[0] ?? "",
      );
      const boundary = oldAccount.lastIndexOf(":");
      return (
        oldAccount.slice(0, boundary) === uid &&
        /^[1-9][0-9]*$/.test(oldAccount.slice(boundary + 1))
      );
    } catch {
      return false;
    }
  });
}

export function assertNoObsoleteSubmission(
  account: string,
  prefix: string,
): void {
  if (obsoleteKeys(account, prefix).length)
    throw Error(
      "A saved request uses an older target. Check Visits, explicitly abandon this request, then reselect its target. Your local draft and audio are retained.",
    );
}

export function discardObsoleteSubmissions(
  account: string,
  prefix: string,
): void {
  for (const key of obsoleteKeys(account, prefix))
    sessionStorage.removeItem(key);
}
